import consumer from "./consumer";

(function () {
  const LeaguesChannelApp = function () {
    const subscribeToChannel = () => {
      consumer.subscriptions.create(
        { channel: "LeaguesChannel", league_id: gon.league_id },
        {
          received(data) {
            if (
              gon.league?.lock_round_edition &&
              data.hasOwnProperty("lock_round_edition") &&
              !data.lock_round_edition
            ) {
              window.location.reload();
            }
          },
        }
      );
    };

    const init = () => {
      if (!gon.league_id || gon.league_id === "") return;

      subscribeToChannel();
    };

    if (!window.$) return;

    $(document).on("turbolinks:load", init);
  };

  if (typeof window !== "undefined") {
    window.LeaguesChannelApp = LeaguesChannelApp;
  }

  return LeaguesChannelApp();
})();
